import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import { ReactNode } from "react"

export type SegmentT = {
    title: string
    icon: ReactNode
    onClick: () => void
    disabled?: boolean
    /** a toggle or one of exclusive options (bold, text align…): whether it is on */
    selected?: boolean
}

interface Props {
    segments: SegmentT[]
}

/**
 * Icon buttons joined into one field that fills its column — Figma's alignment and
 * rotation groups. Each button has the background of the filled inputs next to it; the gap
 * between them lets the panel show through, so they read as separate buttons. A button that
 * is on (`selected`) is lighter, with a white icon.
 */
const SegmentedButtonGroup = ({ segments }: Props) => (
    <Box
        sx={{
            display: "flex",
            gap: "3px",
            width: "100%",
            height: "100%",
            minHeight: 32,
            borderRadius: "2px",
            overflow: "hidden",
        }}
    >
        {segments.map(({ title, icon, onClick, disabled, selected }) => (
            <Tooltip key={title} title={title}>
                {/* span: a disabled button fires no events, so the tooltip needs a wrapper */}
                <Box
                    component="span"
                    sx={{ flex: 1, display: "flex", bgcolor: selected ? "grey.500" : "divider" }}
                >
                    <IconButton
                        size="small"
                        onClick={onClick}
                        disabled={disabled}
                        aria-pressed={selected}
                        sx={{
                            flex: 1,
                            borderRadius: 0,
                            color: selected ? "text.primary" : "text.secondary",
                        }}
                    >
                        {icon}
                    </IconButton>
                </Box>
            </Tooltip>
        ))}
    </Box>
)

export default SegmentedButtonGroup
